module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container bg-none static"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-9 col ideas-size ideas-list"
  }, [_c('div', {
    staticClass: "remove"
  }, [_c('div', {
    staticClass: "widgets-ideas"
  }, [_c('router-link', {
    staticClass: "widgets-ideas-button",
    attrs: {
      "to": {
        name: 'ideas'
      },
      "active-class": "is-active",
      "exact": ""
    }
  }, [_vm._v("\n                        На голосовании\n                        "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.total))])]), _vm._v(" "), _c('router-link', {
    staticClass: "widgets-ideas-button",
    attrs: {
      "to": {
        name: 'inprocess-ideas'
      },
      "active-class": "is-active"
    }
  }, [_vm._v("\n                        В работе\n                        "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.inprocess))])]), _vm._v(" "), _c('router-link', {
    staticClass: "widgets-ideas-button",
    attrs: {
      "to": {
        name: 'completed-ideas'
      },
      "active-class": "is-active"
    }
  }, [_vm._v("\n                        Реализованные\n                        "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.completed))])]), _vm._v(" "), (_vm.isLogged) ? _c('router-link', {
    staticClass: "widgets-ideas-button",
    attrs: {
      "to": {
        name: 'my-ideas'
      },
      "active-class": "is-active"
    }
  }, [_vm._v("\n                        Мои идеи\n                        "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.my))])]) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('router-link', {
    staticClass: "widgets-ideas-button",
    attrs: {
      "to": {
        name: 'starred-ideas'
      },
      "active-class": "is-active"
    }
  }, [_vm._v("\n                        Избранные\n                        "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.starred))])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix menu-forms"
  }, [_c('ul', {
    staticClass: "menu-ideas"
  }, [_c('li', {
    class: {
      'ideas-news': true,
      'active': !_vm.currentSort || _vm.currentSort == 'new'
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.setSort('new')
      }
    }
  }, [_vm._v("Новые")])]), _vm._v(" "), _c('li', {
    class: {
      'ideas-popular': true,
      'active': _vm.currentSort == 'popular'
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.setSort('popular')
      }
    }
  }, [_vm._v("Популярные")])])])]), _vm._v(" "), _vm._l((_vm.ideas), function(idea) {
    return _c('Idea', {
      key: idea.id,
      attrs: {
        "idea": idea
      }
    })
  }), _vm._v(" "), (_vm.currentPage < _vm.totalPages) ? _c('button', {
    staticClass: "button block more",
    on: {
      "click": function($event) {
        _vm.loadIdeas(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("\n                Показать ещё\n            ")]) : _vm._e(), _vm._v(" "), _c('router-view')], 2), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 mobile-menu-ideas"
  }, [(_vm.isAdmin) ? _c('div', {
    staticClass: "menu-admin"
  }, [_c('router-link', {
    staticClass: "widgets-ideas-button",
    attrs: {
      "to": {
        name: 'canceled-ideas'
      },
      "tag": "div",
      "active-class": "is-active"
    }
  }, [_vm._v("\n                    Отклонённые\n                    "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.canceled))])]), _vm._v(" "), _c('router-link', {
    staticClass: "widgets-ideas-button",
    attrs: {
      "to": {
        name: 'moderation-ideas'
      },
      "tag": "div",
      "active-class": "is-active"
    }
  }, [_vm._v("\n                    На модерации\n                    "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counters.moderation))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-category"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('ul', {
    staticClass: "filter-menu"
  }, [_c('li', {
    staticClass: "filter-item all-select",
    class: {
      'active-item': _vm.isCatFilterEmpty()
    },
    on: {
      "click": function($event) {
        _vm.setCategory()
      }
    }
  }, [_c('span', {
    staticClass: "icon-form"
  }), _vm._v("Все\n                    ")]), _vm._v(" "), _vm._l((_vm.rootCategories), function(cat) {
    return _c('li', {
      staticClass: "filter-item",
      class: {
        'active-item': _vm.isCatSelected(cat.id)
      },
      on: {
        "click": function($event) {
          _vm.toggleCategory(cat)
        }
      }
    }, [_c('span', {
      staticClass: "icon-form"
    }), _vm._v("\n                        " + _vm._s(cat.title) + "\n                        " + _vm._s(_vm.counters.categories ? (" - " + (_vm.counters.categories[cat.id] || 0)) : '') + "\n\n                        "), (_vm.categories[cat.id]) ? _c('ul', {
      staticClass: "sec-menu"
    }, _vm._l((_vm.categories[cat.id]), function(child) {
      return _c('li', {
        staticClass: "filter-item",
        class: {
          'active-item': _vm.isCatSelected(child.id)
        },
        on: {
          "click": function($event) {
            _vm.toggleCategory(child)
          }
        }
      }, [_c('span', {
        staticClass: "icon-form"
      }), _vm._v("\n                                " + _vm._s(_vm.counters.categories ? (" - " + (_vm.counters.categories[cat.id] || 0)) : '') + "\n                            ")])
    })) : _vm._e()])
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "button-us"
  }, [_vm._v("Применить")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-close"
  }, [_c('h2', {
    staticClass: "title-filter"
  }, [_vm._v("\n                        Фильтр по категориям"), _c('span', {
    staticClass: "close-menu-form"
  }, [_vm._v("×")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eb7ec8d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ideas.vue
// module id = 110
// module chunks = 0